import { getApi } from './index';
import { UploadsPresignedUrlsResponse } from '../types/api/types';

/**
 * Fetches a S3 presigned URL for uploading files for the specified account.
 *
 * @param accountUid - The account UID for which to generate the presigned URL
 * @returns Promise resolving to the presigned URL response
 */
export const fetchUploadsPresignedUrl = async (
  accountUid: string
): Promise<UploadsPresignedUrlsResponse> => {
  return getApi().uploadsPresignedUrls.post({}, null, { accountUid });
};
